const Industry = {

    // FIELDS
    "name": "Pangalan",
    "description": "Paglalarawan",
    "search": "Maghanap",

    // PAGE HEADER
    "industry": "Industriya",

    // ERROR
    "error_name": "Ilagay ang Pangalan",
    "error_description": "Ilagay ang Paglalarawan",

    // TABLE HEADER
    "table_name": "PANGALAN",
    "table_description": "PAGLALARAWAN",

}

export default Industry;